<template>
  <v-app>
    <Navigation></Navigation>
    <Validator></Validator>
    <Footer></Footer>
  </v-app>
</template>

<script>
import Footer from "./Footer"
import Navigation from "./Navigation"
import Validator from "./Validator"

export default {
  components: {
    Footer,
    Navigation,
    Validator
  },
  data() {
    return {
    }
  }
}
</script>

<style>
</style>
